import { render, staticRenderFns } from "./batchAddFriendNoAuth.vue?vue&type=template&id=5f11848a&scoped=true"
import script from "./batchAddFriendNoAuth.vue?vue&type=script&lang=js"
export * from "./batchAddFriendNoAuth.vue?vue&type=script&lang=js"
import style0 from "./batchAddFriendNoAuth.vue?vue&type=style&index=0&id=5f11848a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11848a",
  null
  
)

export default component.exports